import React from 'react';
import './index.css';
import App from './App';
import * as ReactDOMClient from 'react-dom/client';
import "@nike/eds/dist/index.css";
import {BrowserRouter} from "react-router-dom";
import store from './shared/store/Store';
import { Provider } from 'react-redux';
import { Security } from '@okta/okta-react';
import { oktaAuth } from './shared/config/OktaConfig';

let localClearanceOverviewContainer = null;
let root = null;

window.renderLocalClearanceOverview = (containerId) => {
    console.log("Rendering Local Clearance Overview Microfrontend");
    if (!localClearanceOverviewContainer) {
        localClearanceOverviewContainer = document.getElementById(containerId);
        root = ReactDOMClient.createRoot(localClearanceOverviewContainer);
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <Security oktaAuth={oktaAuth} restoreOriginalUri={() => {}}>
                        <Provider store={store}>
                            <App />
                        </Provider>
                    </Security>
                </BrowserRouter>
            </React.StrictMode>
        );
    }
}

window.unmountLocalClearanceOverview = () => {
    if (root) {
        root.unmount();
    }
    localClearanceOverviewContainer = null;
    root = null;
}